<template>
  <div
    :key="section"
    class="main-section">
    <section v-if="loading">
      <div class="infoba-header">
        <div style="display:flex">
          <i class="fal fa-home" />
          <span
            class="header-link"
            @click="goto(headerLink)">INFOBA</span>
        </div>
        <img
          :src="domain + '/Images/logowhite.svg'"
          class="infoba-logo">
      </div>
      <div
        class="infoba-quick-access-item "
        style="text-align:center; padding:20px !important">
        <div class="material-icons icon-rotator infoba-rotate" />
      </div>
    </section>
    <section v-else-if="section!='default' ">
      <div class="infoba-header">
        <div style="display:flex">
          <i class="fal fa-home" />
          <span
            class="header-link"
            @click="goto(headerLink)">INFOBA</span>
        </div>
        <img
          :src="domain + '/Images/logowhite.svg'"
          class="infoba-logo">
      </div>
      <div class="infoba-quick-access-item">
        <widget-html :html="message" />
      </div>
    </section>
    <section v-else>
      <div
        class="infoba-header"
        style="background-color: #96be2c;">
        <div style="display:flex">
          <div class="icon-clipboard" />
          <div
            class="header-link"
            @click="goto(headerLinkC.url)">
            {{ item.Binder.Tile.Header }}
          </div>
        </div>
        <img
          :src="domain + '/Images/logowhite.svg'"
          class="infoba-logo">
      </div>
      <div class="wrapper">
        <div v-if="item.Binder.Tile.Inspection.InspectionId != null">
          <div
            class="infoba-accordeon-header"
            style=" background-color: #FAFAFA; font-size: 12px; color: #888888;">
            <div>N&aelig;ste tilsyn</div>
          </div>
          <div
            class="infoba-accordeon-row"
            style="border:none; background-color: #FAFAFA;">
            <div style="display:flex; align-items:center; padding-left:15px;padding-bottom:20px;">
              <div
                class="icon-calendar-green"
                style="padding: 20px 10px 0 20px;" />
              <div
                v-if="item.Binder.Tile.Inspection.InspectionId != null"
                class="infoba-link"
                style="font-size: 16px; color: #555555 !important;"
                @click="goto(domain + '/IN/Inspection/Index/'+ item.Binder.Tile.Inspection.InstitutionId)">
                <b>{{ moment(item.Binder.Tile.Inspection.VisitDate).format('DD. MMMM. ') }}</b> {{ moment(item.Binder.Tile.Inspection.VisitDate).format('YYYY') }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="item.Binder.Tile.Inspection.DevelopmentPointList.length != 0"
          style="padding-left: 25px;"
          class="infoba-accordeon-header">
          <div
            class="ellipsis"
            style="display: flex;align-items: center;">
            <div style="color: #555555;">
              <b>{{ item.Binder.Tile.TileSettings.InstitutionSettings.InspectionDevelopmentPointNamePlural }}</b>
            </div>
          </div>
          <i
            v-if="item.Binder.Tile.Inspection.DevelopmentPointList.length != 0"
            class="fas fa-chevron-right rotate chevron"
            :class="{right:open}"
            style="cursor:pointer;"
            @click="open = !open" />
        </div>

        <div
          v-if="item.Binder.Tile.Inspection.DevelopmentPointList.length == 0 && item.Binder.Tile.Inspection.InspectionId == null"
          class="infoba-accordeon-header"
          style=" background-color: #FAFAFA; font-size: 12px; color: #888888;">
          Vi har ikke noget relevant data at vise dig.
        </div>
        <div>
          <template v-for="le in item.Binder.Tile.Inspection.DevelopmentPointList">
            <transition name="slide">
              <div v-show="open">
                <div
                  class="infoba-accordeon-row"
                  style="padding-left:24px; padding-right:20px; align-items:center;">
                  <div
                    style="cursor:pointer"
                    @click="goto(domain + '/IN/Inspection/ActionPlan/' + le.ActionPlanRef.ActionPlanId +'?devPointId=' + le.DevelopmentPointId +'&institutionId=' + le.InstitutionId + '&inspectionId=' + le.InspectionId)">
                    <b>{{ le.Title }}</b>
                  </div>
                  <div
                    class="icon-status-dot"
                    :style="getColor(le.ActionPlanRef.Status)" />
                </div>
                <div
                  class="infoba-accordeon-row infoba-gray"
                  style="padding-left:24px; padding-right:20px; align-items:center; ">
                  <div><b>Frist:</b> {{ moment(le.ClosingDate).format('DD. MMM. YYYY') }}</div>
                  <div>{{ item.Binder.Tile.Inspection.InspectionSelectedType.SeverityList[le.SeverityId].Name }}</div>
                </div>
              </div>
            </transition>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
var domain = 'https://www2.infoba.dk';

export default {
  props: {
    /* normal and secure */
    axios: Function,
    sessionUUID: String,
    placement: String,
    currentWeekNumber: String,
    isMobileApp: Boolean,
    userProfile: String,
    /* only secure */
    moment: Function,
    assuranceLevel: Number,
    getAulaToken: Function,
    childFilter: Array,
    institutionFilter: Array,
    group: String
  },
  data: function () {
    return {
      loading: true,
      section: "default",
      message: "",
      timer: "",
      headerLink: domain,
      who: 'Aula widget developers',
      date: this.moment().format('DD-MM-YYYY'),
      aulaToken: null,
      open: false,
      domain: domain,
      fields: {},
      item: {
        Binder: {
          Tile: {}
        }
      },
    }
  },
  methods: {
    getColor: function (status) {
      return "background-color:" + (status == 0 ? this.item.Binder.Tile.Inspection.InspectionSelectedType.ActionTypeList[0].Color : this.item.Binder.Tile.Inspection.InspectionSelectedType.ActionTypeList[status - 1].Color);
    },
    getData: function () {
      var uuid = this.sessionUUID;
      this.axios.defaults.headers.common["Authorization"] = this.aulaToken;
      this.axios.defaults.headers.common["AuthorizationContext"] = "INTile";
      if (this.childFilter != null)
        this.axios.defaults.headers.common["childFilter"] = this.childFilter.join();
      if (this.institutionFilter != null)
        this.axios.defaults.headers.common["institutionFilter"] = this.institutionFilter.join();
      if (this.group != null)
        this.axios.defaults.headers.common["groupFilter"] = this.group;
      if (this.userProfile != null)
        this.axios.defaults.headers.common["userProfile"] = this.userProfile;
      if (this.currentWeekNumber != null)
        this.axios.defaults.headers.common["currentWeekNumber"] = this.currentWeekNumber;
      if (this.isMobileApp != null)
        this.axios.defaults.headers.common["isMobileApp"] = this.isMobileApp;

      this.axios.get(domain + "/api/Aula/INTileGet/36", {
        withCredentials: true,
        credentials: "same-origin",
      })
        .then((response) => {
          this.moment.locale('da');
          this.item = response.data;
          handleStatus(this);

          if (this.item.Binder.Tile.Inspection.length == 0) {
            this.section = "nodata";
            this.message = "Vi har ikke noget relevant data at vise dig.";
          }
        })
        .catch((error) => {
          handleStatus(this);
        })
        .finally(() => (this.loading = false));
    },
    goto: function (redirectUrl) {
      let serial = this.item.INFOBAserial;
      let token = this.item.INFOBAtoken;
      let url = "";
      //if logged in
      if (serial === null || token === null) {
        let aulaReferrer = '?referrer=Aula';
        if (redirectUrl.indexOf('?') !== -1) {
          aulaReferrer = '&referrer=Aula';
        }
        url = redirectUrl + aulaReferrer;
      }
      //if not logged in
      else {
        url = domain + "/Login/Index?serial=" + serial + "&token=" + token + "&referrer=Aula&returnUrl=" + encodeURIComponent(redirectUrl);
      }
      var a = document.createElement('a');
      a.href = url;
      a.target = "INFOBA";
      a.click();
    }
  },
  computed: {
    headerLinkC: function () {
      if (this.item.Binder.Tile == undefined || this.item.Binder.Tile.Url == undefined || this.item.Binder.Tile.Url.length == 0)
        return { url: "", style: "" };
      else
        return { url: this.item.Binder.Tile.Url };
    },
    loginURL: function () {
      return domain + '/Login?ReturnUrl=' + encodeURIComponent(location.href);
    },
  },
  created: function () {
    this.aulaToken = this.getAulaToken();
    this.moment.locale("da");
  },
  watch: {

    aulaToken: function () {
      if (this.aulaToken !== undefined) {
        var t = this;
        t.getData(false);
      }
    },
  },
}


function handleStatus(t) {
  clearTimeout(t.timer)
  if (t.item && t.item.Status == 200) {
    if (t.item.Binder.Tile == undefined) {
      t.section = "error"
      t.message = 'Din bruger har ikke adgang til denne widget i INFOBA. Kontakt <a href="https://web.infoba.dk/support/" class="infoba-link">support</a>.'
    }
    else {
      t.section = "default"
    }
  }
  else if (t.item && t.item.Status == 401) {
    if (t.item.Message == "Invalid role" || t.item.Message == "Module payment missing") {
      t.section = "error"
      t.message = 'Din bruger har ikke adgang til denne widget i INFOBA. Kontakt <a href="https://web.infoba.dk/support/" class="infoba-link">support</a>.'
    }
    else {
      t.section = "login";
      t.message = 'For at se data fra INFOBA, skal dine konti f&oslash;rst sammenk&aeligdes. <div><a href="' + domain + "/IN/Personel/MatchAula/" + t.item.Username + '" class="infoba-link">Start sammenk&aeligdning <i class="material-icons icon-arrowright-circle" style="vertical-align: middle; margin-top: 2px; color:#96be2c"></i></a></div>';
      t.timer = setTimeout(function () { t.getData() }.bind(t), 5000);
      t.headerLink = domain + "/IN/Personel/MatchAula/" + t.item.Username;
    }
  }
  else {
    t.section = "error"
    t.message = 'Undskyld. Det er i &oslash;jeblikket ikke muligt at vise dig den &oslash;nskede information. Vi h&aring;ber, du vil pr&oslash;ve igen senere.'
  }
}
</script>
<style scoped>
div.icon-clipboard {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA8ElEQVRIx+2UQWoCQRBFf0UleAfJIbIMeoDgDdxk5xWydJZhzDEEQW+RK+gN2p0XyEJ5bnqCTGba6bEFCfnQ0FR1/1dU0S3dg4Ae8Ans/cqBbkrAnN/K2xiNgR31egGGgbwDXs89rQRwkgaBGkb+zlfgjDOzpzoAKVpqZj++DykMQ0oB2NwSsJb0LCm7BWAtaWJmB5VmWSuaa1U8NCArJ2MA24rYMmQeA5gBHWDRtPIqQOg/6ZvZEXiThKTHoudAJmkWPbWKYjIf7zapvM0MAD7O8hfNY1pU6B349vvotvy9v2iXwNOFANMrIc57/Ku5Tvsu1izwqqlOAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTEwLTEzVDEyOjAxOjA0KzAwOjAwIUs5FQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0xMC0xM1QxMjowMTowNCswMDowMFAWgakAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC) no-repeat center center;
  background-size: 20px;
  padding: 35px 0 0 35px;
  display: inline-block;
}

div.icon-rotator {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAD5UlEQVRo3u2ZT4gbdRTHv++XJUzwT6HuoUrB0nhQKR6kerG9eCgL1l3FdT1ZpLB4kL1Edmf29rtlJpsuSPEgQvdiD6ZQdS1ioTf/gFUQ24KSS3qQIloKVXGSyWa+Hjq7JNNkMzOZcT3M9zZv5v3m98n7vfd+8wuQK1euXLlyJZekPaDW+mHDMI6TPCIijwPYB2ALwB2SvwH4rtPp/KC1/vt/B6K1njIMYx7AaQAvAiiMcekC+ALARrvd/lxr7e85iOM48yQdAIeT+JO8JiIrlmVdnmQeU0kd19fX93ued47k3CQTEJEnRaQ0yRhAwohUq9UnROQyRkdhC8BVki0R+V1EPJLTAJ4C8CwAI3jOE5E3TNP89D8HCSC+AnBgyO2fAKwXi8VLlUrlzjB/rfWDhmHMAlgSEScNiNggwXL6HvdH4raIVFzXPZ9G4iZRrBzxPO9cGEJEbiilZpeXl1t7AbAtFfVBx3HmAQwktojccF33hawgHMc5mCqI1noqKLH9uq2UmtVa/5kFRLVanSHZtG37ndRAgmYXXlKVrCJRrVZnROQTACUAZ6PARF1ap/svSF5zXfd8RhAnAojtEi0BzNJEILZt78O9bceORORMFtUpiMRnfRA7rwTw3m6RiRKRYxjcO20Vi8VLGUH0RyKs7cgMhRkLQvJIyHR1VLPLEGIszFgQpdShkOnmHkHsCjMWxPf9h0KmWylCnIgJEYZZ6jcAAGzbXgTwAZJtJD2l1GsrKyup5I5t22cAVPpMH1mW9eZuPjsRsSzrQwBLABjzvW2Sc2lBBHqs/4Lk2KY7sLQsy3o/Jkyb5Kurq6tfpggBAIdC1zdjgcSEyQSiXq9PA3guZL4eGyQiTFaRQK/XexmDfaurlPomEUgfzNtDYDyl1OtZQDQajQIGkxwArpim+VdikAAmXACySOwdtVqtU+EGTHIjiu/YPtK3zNyslhMA1Gq1Msl6yNwsl8sXo/hH7hmO4xw0TfPXLCCCjem3AJ4emJzInGmam6mCZKVarVb2fX9zCMQF0zQXoo6T+FxrUjUajUKr1Trl+34dwP7Q7SbJxTjjpRYRx3FeIWmJyFkAm6MqTb1en+52uyeVUu8O2VkDwK1CoXAs7tdnKiABxMcAioGpLSI/kvxZRP4gWRSRAyQPAziK0WfDzUKhMJPkEzqNs98wRCKJyAWSi5Zl3U3iP3GO+L7/D4BfROSZhEM0RWQ5anUa+UNMCgIAWmtVKpVOknwLwEsYH50ugCskN8rl8sWFhYXepHNIvfyura09QPJor9d7XkQeBfAIyQKAu7i3i73e6XS+TvuPnly5cuXKlWsS/QvhKq1sLYByvgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0xMC0wNlQxMTozNjo1NSswMDowMPTXOyYAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMTAtMDZUMTE6MzY6NTUrMDA6MDCFioOaAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==) no-repeat center center;
  padding: 25px 25px 25px 25px;
  display: inline-block;
}

div.icon-calendar-green {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABXElEQVRIx92VMUtCYRSGn3PV/AGWhmlrkHdz18yx3amhFhEdG1zvJDg0JlkE7f2AltBoNir0H+QQgotLKHlPQwQWV7PrFaJ3PN/5znPOy+H74N+q1jC11jB10Txj2Y3Kt272gDqw4bJYV1XyxWz72nECgVO3xQEUYojWp1qkEPPAlfhUwDK0dIDfKVjc7chvC8HHys4FcLzcNPdRqYL6VaRcyrQvPbPo/MaMoFyARoGwqJ6dNBPrngHGPuLAykQooLYv6hnghdVHVB4mQvfh/taTZwArc/sWDI7SIlIQkYKK7uRyV2PPAPVWMvA68m1jaw9be6qaqLeSgXnuztwiy8IIp8zyeDA8MjBCKp9dGYwHw36tYR737jpVy8J2NcFa2jwEKkDI4TgEVCIp88C9RfbXd8UxRdl0bVEp27EA6yfI3ACBrkJsnp9shp6nWqQqeYHuIsVVNL/IxH9P77i1cnmY9ATIAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTEwLTA5VDE0OjA1OjQxKzAwOjAwLSIWgAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0xMC0wOVQxNDowNTo0MSswMDowMFx/rjwAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC) no-repeat center center;
  background-size: 20px;
  padding: 35px 0 0 35px;
  display: inline-block;
}

i {
  font-size: 14px;
}

i.chevron {
  margin-right: 10px;
  height: 14px;
}
.header-link {
  cursor: pointer;
  margin-left: 5px;
  line-height: 35px;
}

.main-section {
  border: 2px solid white;
  background-color: #FAFAFA;
}

.wrapper {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.infoba-header {
  color: #fff;
  padding: 4px;
  padding-left: 8px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  background: #888;
  position: relative;
  margin-top: 20px
}

.infoba-header:first-child {
  margin-top: 0
}

.infoba-header i {
  position: absolute;
  top: 2px;
  line-height: 35px;
  font-size: 24px !important
}

.infoba-header span {
  position: absolute;
  left: 34px;
  line-height: 35px;
  color: #fff;
  cursor: pointer;
  top: 5px
}

.quick-access-item {
  position: relative
}

.infoba-quick-access-item {
  padding: 20px 35px 20px 35px;
  cursor: auto;
  height: auto
}

.infoba-gray {
  color: #888
}

.infoba-link {
  color: #888 !important;
  cursor: pointer
}

.slide-enter-active {
  -moz-transition-duration: .3s;
  -webkit-transition-duration: .3s;
  -o-transition-duration: .3s;
  transition-duration: .3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in
}

.slide-leave-active {
  -moz-transition-duration: .3s;
  -webkit-transition-duration: .3s;
  -o-transition-duration: .3s;
  transition-duration: .3s;
  -moz-transition-timing-function: cubic-bezier(0,1,.5,1);
  -webkit-transition-timing-function: cubic-bezier(0,1,.5,1);
  -o-transition-timing-function: cubic-bezier(0,1,.5,1);
  transition-timing-function: cubic-bezier(0,1,.5,1)
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0
}

.rotate {
  -moz-transition: all .3s linear;
  -webkit-transition: all .3s linear;
  transition: all .3s linear
}

.rotate.right {
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg)
}

.rotate.up {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg)
}

.infoba-rotate {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite
}

@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg)
  }

  to {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg)
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg)
  }

  to {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg)
  }
}

.infoba-accordeon {
  padding-left: 5px
}

.infoba-accordeon-header {
  padding-left: 24px;
  background-color: #FFFFFF;
  line-height: 46px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
}

.infoba-accordeon-row {
  background-color: #FFFFFF;
  padding-left: 5px;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
}

.infoba-accordeon-row:last-child {
  padding-bottom: 20px;
}

.infoba-logo {
  height: 35px
}
</style>
